import * as Yup from 'yup';

const schema = Yup.object().shape({
    ano: Yup.string().required('O campo deve ser preenchido'),
    vendedorId: Yup.string().required('Selecione uma opção')
});

export default schema;